<template>
  <div class="myBox" :class="{noborder:noborder, nopadding:nopadding}">
    <div class="mt-4">
      <h2 class="mb-1" :class="{kiosk:$store.getters.isKiosk}">Zahlungsarten</h2>
      <!--                            <h4 class="mb-1"><span class="mr-1 hidden-xs-only">Akzeptierte</span>Zahlungsarten</h4>-->
      <div class="d-flex flex-wrap" style="max-width: 520px">
        <!--                                <v-img contain width="1.8vw" :src="require('../assets/payment/bar.png')"></v-img>-->
        <v-img v-if="enableGoodpay" contain width="10%" :src="require('../assets/payment/applepay.png')"></v-img>
        <v-img v-if="enableGoodpay" contain width="10%" :src="require('../assets/payment/googlepay.png')"></v-img>
        <v-img v-if="enableGoodpay" contain width="10%" :src="require('../assets/payment/visa.png')"></v-img>
        <v-img v-if="enableGoodpay" contain width="10%" :src="require('../assets/payment/mastercard.png')"></v-img>
        <v-img v-if="enableGoodpay" contain width="10%" :src="require('../assets/payment/american-express.png')"></v-img>
<!--        <v-img v-if="enableGoodpay" contain width="10%" :src="require('../assets/payment/discover.png')"></v-img>-->
        <v-img v-if="enablePaypal && !$store.getters.isKiosk" contain width="10%"
               :src="require('../assets/payment/paypal.png')"></v-img>
        <v-img v-if="enablePaypal && !$store.getters.isKiosk" contain width="10%"
               :src="require('../assets/payment/sepa.png')"></v-img>
        <v-spacer></v-spacer>
      </div>
      <div class="pt-4">
        <h4 v-if="!$store.getters.isKiosk">{{ displayPaymentMethods | stringList }}</h4>
        <h4 v-else class="kiosk">{{ displayPaymentMethodsKiosk | stringList }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
import {enableGoodpay, enablePaypal} from "@/vendor/qconstants";
import {displayPaymentMethods} from "../vendor/qconstants";

export default {
  name: "Zahlungsarten",
  data: () => ({
    enablePaypal: enablePaypal,
    enableGoodpay: enableGoodpay,
    displayPaymentMethods: displayPaymentMethods,
  }),
  props: {
    noborder: {
      default: false,
      type: Boolean
    },
    nopadding: {
      default: false,
      type: Boolean
    },
  },
  computed: {
    displayPaymentMethodsKiosk() {
      return displayPaymentMethods.filter(m => m !== 'PayPal');
    },
  },
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.myBox {
  color: $font-color;
  border: 3px solid $accent;
  padding: 2.5vw;
  margin: 10px;
  border-radius: $box-border-radius;

  &.noborder {
    border-color: transparent;
  }

  &.nopadding {
    padding: 0;
    margin: 0;
  }
}

h2.kiosk {
    color: white;
}
h4.kiosk {
  color: white;
}

</style>
